import { Checkbox, TableCell, TableHead, TableRow } from "@material-ui/core";

import i18next from "i18next";
import "./i18n";
import React, { FunctionComponent, useEffect, useState } from "react";
import { EnhancedTableProps, HeadCell } from "./types";

const EnhancedTableHead: FunctionComponent<EnhancedTableProps> = (
  props: EnhancedTableProps
) => {
  const { onSelectAllClick, numSelected, rowCount } = props;
  const [headCells, setHeadCells] = useState<HeadCell[]>([]);

  useEffect(() => {
    const headCellsNew: HeadCell[] = props.keys.map((key: string) => {
      return {
        id: key,
        numeric: false,
        disablePadding: true,
        label: key,
      };
    });
    setHeadCells(headCellsNew);
  }, [props.keys]);

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
        <TableCell padding="none" align="left">
          {i18next.t("ENHANCED:VARIABLE")}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
